import { Component, HostBinding, OnInit } from '@angular/core';
import Fraction from 'fraction.js';
import { AppSettings } from '../app.settings';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Donation } from '../transaction-store/donation';
import { Router } from '@angular/router';

@Component({
  selector: 'app-impact',
  template: `
    <div class="row impact-illustration">
      <div class="col text-center" *ngIf="display.money">
        <div class="row">
          <div class="col-12">
            <span class="icon icon-cash primary-color"></span>
          </div>
          <div class="col-12">
            <span class="primary-color">{{
              (donation$ | async).amount
                | currency: currencyCode:'symbol-narrow'
            }}</span>
          </div>
        </div>
      </div>
      <div
        class="col-2 text-center provides"
        *ngIf="display.icon && display.money"
      >
        <div class="row">
          <div class="col-12">
            <span class="icon icon-right-caret primary-color"></span>
          </div>
          <div class="col-12">
            <span class="primary-color">PROVIDES</span>
          </div>
        </div>
      </div>
      <div class="col text-center" *ngIf="display.icon">
        <div class="row">
          <div class="col-12">
            <span class="icon icon-{{ icon }} primary-color"></span>
          </div>
          <div class="col-12">
            <span class="primary-color"
              >&nbsp;{{ iconAmount }} {{ result }}</span
            >
          </div>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class ImpactComponent implements OnInit {
  @HostBinding('class.col') col = true;
  @HostBinding('class.border-right') br = true;
  @HostBinding('class.border-primary') bp = true;
  display;
  icon;
  result;
  value;
  iconAmount;
  currencyCode = 'USD';

  @Select() donation$: Observable<Donation>;

  constructor(private settings: AppSettings, private router: Router) {
    this.currencyCode = this.settings.getValue('organization').currency_code;
    const properties = this.settings.getValue('properties');
    const impactDisplay = properties.impact_equation_display;
    this.display = {
      icon: impactDisplay.includes('icons'),
      money: impactDisplay.includes('monetary')
    };
    this.icon = properties.impact_equation_icon;
    this.result = properties.impact_equation_result;
    this.value = properties.impact_equation_value;
    this.donation$.subscribe(val => {
      if (this.value) {
        this.iconAmount = `${val.amount / this.value}`;
        if (this.iconAmount < 1) {
          this.iconAmount = new Fraction(
            (Math.round(+this.iconAmount * 10) / 10).toFixed(2)
          ).toString();
        } else {
          this.iconAmount = Math.floor(+this.iconAmount);
        }
      }
    });
  }

  ngOnInit() {
    if (this.router.url === '/thank-you') {
      this.br = false;
    }
  }
}
